<div class="dashboard-settings-sidebar" *ngIf="sidenavType$ | async as sidenavType">
  <ul *ngIf="sidenavType === SideNavType.SETTINGS">
    <ng-container *ngFor="let settingsSideMenuItem of settingsSideMenuItems">
      <li class="dashboard-settings-sidebar__items">
        <a
          class="dashboard-settings-sidebar__items-link"
          [routerLink]="settingsSideMenuItem.link"
          routerLinkActive="active"
          >{{ settingsSideMenuItem.name }}</a
        >
      </li>
    </ng-container>
  </ul>
  <ul *ngIf="sidenavType === SideNavType.CREATE">
    <ng-container *ngFor="let createMenuItem of createMenuItems; first as isFirst">
      <li class="dashboard-settings-sidebar__items">
        <a class="dashboard-settings-sidebar__items-link" [routerLink]="createMenuItem.link" routerLinkActive="active">
          <mat-icon *ngIf="isFirst" class="dashboard-settings-sidebar__items-link--icon">arrow_back_ios</mat-icon>
          {{ isFirst ? (createMenuItem.name | uppercase) : createMenuItem.name }}</a
        >
      </li>
    </ng-container>
  </ul>
  <ul *ngIf="sidenavType === StudyType.TIIM">
    <ng-container *ngFor="let tiimMenuItem of tiimMenuItems; first as isFirst">
      <li class="dashboard-settings-sidebar__items" *ngIf="privilegeService.hasPrivilege(tiimMenuItem?.section)">
        <a class="dashboard-settings-sidebar__items-link" [routerLink]="tiimMenuItem.link" routerLinkActive="active">
          <mat-icon *ngIf="isFirst" class="dashboard-settings-sidebar__items-link--icon">arrow_back_ios</mat-icon>
          {{ isFirst ? (tiimMenuItem.name | uppercase) : tiimMenuItem.name }}
          <mat-icon
            *ngIf="tiimMenuItem.error_msg && !checkIfCompleteSubscriptionTranslations()"
            style="color: red"
            matTooltip="{{ tiimMenuItem.error_msg }}"
            >!</mat-icon
          >
        </a>
      </li>
    </ng-container>
  </ul>
  <ul *ngIf="sidenavType === StudyType.CC">
    <ng-container *ngFor="let ccMenuItem of ccMenuItems; first as isFirst">
      <li class="dashboard-settings-sidebar__items" *ngIf="privilegeService.hasPrivilege(ccMenuItem?.section)">
        <a class="dashboard-settings-sidebar__items-link" [routerLink]="ccMenuItem.link" routerLinkActive="active">
          <mat-icon *ngIf="isFirst" class="dashboard-settings-sidebar__items-link--icon">arrow_back_ios</mat-icon>
          {{ isFirst ? (ccMenuItem.name | uppercase) : ccMenuItem.name }}
        </a>
      </li>
    </ng-container>
  </ul>
</div>
